import * as types from './constants';

const initialState = {
  suggestions: [],
  suggestionsToDisplay: null,
  loading: false,
  errors_api: {}
};

const actions = {
  [types.GET_AI_PROMPT_SUGGESTIONS_REQUEST]: state => ({
    ...state,
    loading: true,
    errors_api: {}
  }),

  [types.GET_AI_PROMPT_SUGGESTIONS_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    suggestions: payload
  }),

  [types.GET_AI_PROMPT_SUGGESTIONS_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload || {}
  }),

  [types.SET_SUGGESTIONS_TO_DISPLAY]: (state, { payload }) => ({
    ...state,
    suggestionsToDisplay: payload
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
